<template>
  <div class="section">
    <b-loading v-if="isloading" :is-full-page="true"/>

    <div v-else class="container">
      <div class="buttons is-right">
        <b-button type="is-primary" :disabled="!hasMvts" @click="exportScanMvts">
          {{ $t('global.export') }}
        </b-button>
      </div>

      <ag-grid-vue
        style="width: 100%; height: 1000px;"
        class="ag-theme-alpine"
        :modules="modules"
        :pagination="true"
        :pagination-auto-page-size="true"
        :group-display-type="groupDisplayType"
        :grid-options="gridOptions"
        :row-data="mvts"
        :column-defs="columnDefs"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { AllModules } from '@ag-grid-enterprise/all-modules'
import XLSX from 'xlsx'
import ShippingManagement from '@/services/v2/shippingManagement'

export default {
  data () {
    return {
      modules: AllModules,
      groupDisplayType: 'custom',
      isloading: false,
      mvts: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      selectedCustomer: state => state.selectedCustomer
    }),
    gridOptions () {
      return {
        autoGroupColumnDef: {
          headerName: this.$t('customer.scan_mvt.grid.date')
        }
      }
    },
    columnDefs () {
      return [
        { headerName: this.$t('customer.scan_mvt.grid.date'),
          field: 'scannedDate',
          rowGroup: true,
          hide: true
        },
        { headerName: this.$t('customer.scan_mvt.grid.barcode'),
          field: 'barcode'
        },
        { headerName: this.$t('customer.scan_mvt.grid.scanned_at'),
          field: 'scannedAt'
        },
        { headerName: this.$t('customer.scan_mvt.grid.updated_at'),
          field: 'updatedAt'
        }
      ]
    },
    hasMvts () {
      return !!(this.mvts && this.mvts.length)
    }
  },
  watch: {
    selectedCustomer (newValue, oldValue) {
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      if (!this.selectedCustomer) return
      this.isloading = true
      try {
        const mvts = await ShippingManagement.getScanMvts(this.selectedCustomer)
        this.mvts = mvts.map(mvt => ({
          ...mvt,
          scannedDate: this.formatLocalDate(mvt.scannedAt),
          scannedAt: this.formatLocalDateTime(mvt.scannedAt),
          updatedAt: this.formatLocalDateTime(mvt.updatedAt)
        }))
      } catch (error) {
        this.$buefy.toast.open({
          message: this.$t('customer.scan_mvt.errors.load_data'),
          type: 'is-danger',
          duration: 5000
        })
      } finally {
        this.isloading = false
      }
    },
    formatLocalDate (value) {
      if (!value) return ''
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''
      return date.toLocaleDateString()
    },
    formatLocalDateTime (value) {
      if (!value) return ''
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return ''
      return date.toLocaleString()
    },
    exportScanMvts () {
      if (!this.hasMvts) return

      const columns = [
        { header: this.$t('customer.scan_mvt.grid.date'), field: 'scannedDate' },
        { header: this.$t('customer.scan_mvt.grid.barcode'), field: 'barcode' },
        { header: this.$t('customer.scan_mvt.grid.scanned_at'), field: 'scannedAt' },
        { header: this.$t('customer.scan_mvt.grid.updated_at'), field: 'updatedAt' }
      ]
      const data = [
        columns.map(column => column.header),
        ...this.mvts.map(mvt => columns.map(column => mvt[column.field] || ''))
      ]
      const worksheet = XLSX.utils.aoa_to_sheet(data)
      const workbook = XLSX.utils.book_new()
      const fileDate = new Date().toISOString().slice(0, 10)

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Scan movements')
      XLSX.writeFile(workbook, `GPS-${this.$t('sidebar.scan_mvt')}-${fileDate}.csv`)
    }
  }
}
</script>
